'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BaseSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('@esnpm/translate');

var _BaseInput2 = require('./BaseInput');

var _BaseInput3 = _interopRequireDefault(_BaseInput2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseSelect = exports.BaseSelect = (_temp = _class = function (_BaseInput) {
	_inherits(BaseSelect, _BaseInput);

	function BaseSelect(props) {
		_classCallCheck(this, BaseSelect);

		var _this = _possibleConstructorReturn(this, (BaseSelect.__proto__ || Object.getPrototypeOf(BaseSelect)).call(this, props));

		if (props.value == null) {
			if (props.placeHolder != null) {
				_this.state.val = '';
			} else {
				_this.state.val = props.options[0].value;
			}
		}
		return _this;
	}

	// componentWillReceiveProps(nextProps) {
	// 	// console.log('componentWillReceiveProps');
	// 	if (!nextProps.ignoreValueUpdates) {
	// 		if (nextProps.value != this.state.val) {
	// 			// if (nextProps.value != this.state.val) {
	// 			// console.log('Next', nextProps.value, this.props.value, nextProps.value == this.props.value, this.state.val);
	// 			this.performOnChange(nextProps.value);
	// 			// }
	// 		}
	// 	}
	// }

	_createClass(BaseSelect, [{
		key: 'handleOnChange',
		value: function handleOnChange(e) {
			e.preventDefault();
			// console.log("handleOnChange", e.target.value);
			this.performOnChange(e.target.value);
		}
	}, {
		key: 'performOnChange',
		value: function performOnChange(val) {
			// console.log('performOnChange', val);
			if (this.state.val != val) {
				this.setVal(val);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var UnsetWidth = false;
			if (this.props.size !== null) {
				UnsetWidth = true;
			}

			return _react2.default.createElement(
				_reactBootstrap.FormControl,
				{
					name: this.props.fieldName,
					className: (0, _classnames2.default)(this.props.className, {
						disabled: this.props.disabled
					}, { "UnsetWidth": UnsetWidth }),
					componentClass: 'select',
					bsSize: this.props.bsSize,
					value: this.state.val,
					disabled: this.props.disabled,
					onChange: this.handleOnChange.bind(this),
					onFocus: function onFocus() {
						_this2.props.onFocus();
					},
					size: this.props.size,
					maxLength: this.props.maxLength
				},
				this.renderPlaceHolder(),
				this.renderOptions()
			);
		}
	}, {
		key: 'renderOptions',
		value: function renderOptions() {
			var _this3 = this;

			var options = this.props.options;
			if (options == null) return null;
			if (options.length == 0) return null;

			var intermediateOptions = options.map(function (entry) {
				var text = entry.text;
				if (entry.text == null && entry.textTr != null) {
					text = _this3.props.trProvider.tr(entry.textTr);
				}
				return { value: entry.value, text: text, className: entry.className };
			});

			if (this.props.sortEntries) {
				intermediateOptions.sort(function (a, b) {
					return a.text.localeCompare(b.text);
				});
			}

			return this.realRenderOptions(intermediateOptions);
		}
	}, {
		key: 'realRenderOptions',
		value: function realRenderOptions(intermediateOptions) {
			return intermediateOptions.map(function (entry) {
				return _react2.default.createElement(
					'option',
					{ key: entry.value, value: entry.value, className: entry.className },
					entry.text
				);
			});
		}
	}, {
		key: 'renderPlaceHolder',
		value: function renderPlaceHolder() {
			if (this.props.noPlaceHolder) return null;

			var text = this.props.placeHolder;
			if (text == null && this.props.trPlaceHolder != null) {
				text = this.props.trProvider.tr(this.props.trPlaceHolder);
			}
			if (text == null) return null;

			return _react2.default.createElement(
				'option',
				{ key: 'placeHolder', value: '', hidden: true },
				text
			);
		}
	}]);

	return BaseSelect;
}(_BaseInput3.default), _class.defaultProps = Object.assign({}, _BaseInput3.default.defaultProps, {
	value: '',
	sortEntries: true,
	options: null,
	componentOptions: false,
	ignoreValueUpdates: true
}), _class.propTypes = Object.assign({}, _BaseInput3.default.propTypes, {
	value: _propTypes2.default.string,
	sortEntries: _propTypes2.default.bool,
	componentOptions: _propTypes2.default.bool,
	options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		value: _propTypes2.default.any,
		text: _propTypes2.default.string,
		textTr: _propTypes2.default.string
	})),
	ignoreValueUpdates: _propTypes2.default.bool
}), _temp);
exports.default = (0, _redux.compose)(_translate.withTrContext)(BaseSelect);